import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useCart } from "@/lib/cart";
import CartDrawer from "./CartDrawer";
import { ShoppingCart } from "lucide-react";
import MobileBottomNav from "./MobileBottomNav";

export default function SiteLayout() {
    const { count } = useCart();
    return (
        <div className="min-h-screen bg-white text-brand-navy flex flex-col">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <MobileBottomNav />
            <div className="hidden lg:block fixed right-2 top-1/2 -translate-y-1/2 z-[999]">
                <CartDrawer>
                    <CartDrawer>
                        <button className="relative bg-[#08145A] hover:bg-[#0B1B75] text-white py-2.5 md:py-3 px-4 md:px-5 rounded transition-all shadow-[0_4px_12px_rgba(0,0,0,0.25)] border border-white/10">
                            <ShoppingCart className="w-5 h-5" />
                            {count > 0 && (
                                <span className="absolute -top-1 -right-1 bg-[#D61F1F] text-white text-[10px] font-bold rounded-full min-w-[18px] h-5 px-1 flex items-center justify-center">
                                    {count}
                                </span>
                            )}
                        </button>
                    </CartDrawer>
                </CartDrawer>
            </div>
        </div>
    );
}
